var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3D00",
  fillRule: "evenodd",
  d: "M11.25.5h-7.5L0 5.143 7.5 13.5 15 5.143zM6.89 8.53 4.874 3.177l1.535-.002 1.128 3.96 1.175-3.96 1.413.002-2.02 5.35z",
  clipRule: "evenodd"
})));
export default SvgVip;